import { ContainerBtnGroupCollection } from "./styles";

const BtnGroupCollection = ({ 
    onCancel, 
    onOk, 
    cancelText = "Cancelar", 
    okText = "OK", 
    okType = "submit" 
}) => {

    return (
        <ContainerBtnGroupCollection className="container-btn-group-collection">
             <button type="button" onClick={onCancel}>{cancelText}</button>
             <button type={okType} onClick={onOk}>{okText}</button>
        </ContainerBtnGroupCollection>
    );
}

export default BtnGroupCollection;